import React from "react";
import { Home } from "lucide-react";

// Image
import logo from "assets/images/SOILOGO.png"
import error404 from "assets/images/auth/error-404.png"
import { Link } from "react-router-dom";
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";

const Pages404: React.FC<WithTranslationProps> = ({
    t
}) => {

    return (
        <React.Fragment>
            <div className="flex flex-col justify-center items-center">
                <Link to="/">
                    <img src={logo} alt="" className="h-32 mx-auto dark:block" />
                </Link>

                <div className="mt-10">
                    <img src={error404} alt="" className="h-64 mx-auto" />
                </div>
                <div className="mt-8 text-center">
                    <h4 className="mb-2 text-custom-500">{t('Not Found.Title1')}</h4>
                    {/* <p className="mb-6 text-slate-500 dark:text-zink-200">It will be as straightforward as Occidental; in fact, it will be just like Occidental to an English speaker.</p> */}
                    <Link to="/" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                        <Home className="inline-block w-3 h-3 ltr:mr-1 rtl:ml-1"></Home> <span className="align-middle">{t('Not Found.Button1')}</span>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withTranslation(Pages404);